export default __webpack_public_path__ + "static/media/fire-protection.bfae4494.png";